/**
 * Thin wrapper that exposes the global vue-i18n `t()` function and current locale
 * to plain TypeScript modules (Pinia store, intent engine) that cannot use `useI18n()`.
 *
 * Uses the singleton i18nInstance created by src/i18n/index.js.
 */

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore — JS module without type declarations
import type { ComposerTranslation } from 'vue-i18n'

import i18n from '@/i18n'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const instance = (i18n as any).getInstance()

/**
 * Returns the global translation function, equivalent to `t()` from `useI18n()`.
 * Safe to call at module initialisation time — the i18n instance is a synchronous singleton.
 */
export function getT(): ComposerTranslation {
  return instance.global.t as ComposerTranslation
}

/**
 * Returns the currently active locale string, e.g. 'de', 'en', 'de-CH'.
 */
export function getCurrentLocale(): string {
  return instance.global.locale.value as string
}

/** Maps locale codes to human-readable language names for system prompts. */
export const LOCALE_NAMES: Record<string, string> = {
  de: 'German',
  'de-CH': 'German (Swiss)',
  en: 'English',
  'en-US': 'English',
  fr: 'French',
  it: 'Italian',
}
